export default __webpack_public_path__ + "static/media/NR.70356aea.svg";